<template>
  <admin-list v-bind:whitelabel="false" />
</template>

<script>
import AdminList from "./AdminList";

export default {
  name: 'AdminPanel',
  components: { AdminList }
}
</script>


